import { type NotificationType } from './notification-type.enum'

export abstract class AbstractNotification {
	abstract id: NotificationType
}
